import React from "react";
import { Route, Routes } from "react-router-dom";

import NotificationsTemplates from "./components/NotificationsTemplates";


const NotificationRoutes = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route path="/" element={<NotificationsTemplates />}>
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default NotificationRoutes;
